// extracted by mini-css-extract-plugin
export default {"new-expense":"NewExpense_new-expense__XA4Bb","new-expense__button":"NewExpense_new-expense__button__LWJ4o"};